import React, { useState } from "react";
import { Grid, CircularProgress } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { Pagination } from "@material-ui/lab";
import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import moment from "moment";

import { Card, CardContent, CardActions } from "../../components/Card";
import Table from "../../components/Table";
import { useAlert } from "../../components/Alert";

const GET_PERSONALMESSAGES = gql`
  query personalMessages(
    $id: Int
    $type: PersonalMessageType
    $latest: Boolean
    $pageSize: Int
    $page: Int
  ) {
    personalMessages(
      id: $id
      type: $type
      latest: $latest
      pageSize: $pageSize
      page: $page
    ) {
      count
      pageCount
      contents {
        id
        foreclosureUpdateLog
        createdAt
        updatedAt
      }
    }
  }
`;

export default function ForeclosureUpdateLogTable() {
  const [page, setPage] = useState(1);
  const Alert = useAlert();
  const history = useHistory();
  const { data, loading } = useQuery(GET_PERSONALMESSAGES, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    variables: {
      id: Number(localStorage.getItem("@fullhouseUserId")),
      type: "FORECLOSUREUPDATE",
      latest: true,
      pageSize: 10,
      page,
    },
    onError(error) {
      return Alert.notice(error.message.replace("GraphQL error: ", ""));
    },
  });

  if (loading) {
    return (
      <Grid container item justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return (
      <Card>
        <CardContent>
          <Table
            data={data?.personalMessages.contents ?? []}
            tableWidth={2}
            header={["訊息", "更新時間"]}
            columns={[
              (item) => item.foreclosureUpdateLog,
              (item) => moment(item.createdAt).format("yyyy-MM-DD"),
            ]}
            onPress={() => {
              history.replace("/console/new-favorite");
            }}
          />
        </CardContent>
        <CardActions>
          <Grid container justifyContent="center">
            <Pagination
              count={
                Boolean(data) && data.personalMessages.pageCount
                  ? data.personalMessages.pageCount
                  : 1
              }
              size="large"
              color="primary"
              page={page}
              onChange={(e, n) => {
                setPage(n);
              }}
            />
          </Grid>
        </CardActions>
      </Card>
    );
  }
}
